import { render, staticRenderFns } from "./Acountactive.vue?vue&type=template&id=8438c2a0"
import script from "./Acountactive.vue?vue&type=script&lang=js"
export * from "./Acountactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports